import { AccountBalance, CryptoExchangeRate, CurrencyDefinition } from "../http/protocol";
import Big from "big.js";
import CurrencyFormatter from "../utils/CurrencyFormatter";

export const hasFiatExchangeAmount  = (code : string, preferredExchangeCurrency? : string, currencyDefinitions?: CurrencyDefinition[]) : boolean=> {
    if(!preferredExchangeCurrency || !currencyDefinitions) {
        return false;
    }
    let currency = currencyDefinitions.find(c => c.code == code);
    if(!currency) {
        return false;
    }
    return !!(currency?.cryptoPrices?.[preferredExchangeCurrency]);
}

export const getExchangeRate = (code : string, fiatCode? : string, currencyDefinitions? : CurrencyDefinition[]) : CryptoExchangeRate => {
    if(!fiatCode || !currencyDefinitions) {
        return { rate : 0 };;
    }
    let currency = currencyDefinitions.find(c => c.code == code);
    if(currency && currency.cryptoPrices?.[fiatCode]) {
        return currency.cryptoPrices?.[fiatCode];
    }
    return { rate : 0 };
}

export const toFiatAmount = (code : string, amount : number,  fiatCode? : string, currencyDefinitions? : CurrencyDefinition[]) => {
    let exchange = getExchangeRate(code,fiatCode, currencyDefinitions);
    if(typeof(amount) != "undefined" && typeof(exchange.rate) != "undefined") {
        let exchanged = new Big(amount).times(new Big(exchange.rate));
        return CurrencyFormatter.formatWithSymbol(exchange.currencyDefinition, exchanged);
    }
}


export const getCurrencyName = (props: {currencies: CurrencyDefinition[], currency: string} ) => {
    let currencyName = props.currencies && props.currencies.filter((currencyDef: CurrencyDefinition) => {
        if (props && props.currency && currencyDef.code == props.currency) {
            return currencyDef.name;
        }
    });
    if (currencyName && currencyName.length > 0) {
        return currencyName[0].name;
    } else {
        return props.currency;
    }
}
export interface CurrencyAmount {
  type: "fiat" | "crypto";
  amount: number;
  euroAmount?: Big;
  code: string;
}

export const getCurrencyAmount = (currency: CurrencyDefinition, balance: AccountBalance, fiatCurrencyCode: string, currencyDefinitions: CurrencyDefinition[]): CurrencyAmount => {
  const isFiat = !currency.cryptoCurrency;

  if (isFiat) {
    return (
      {
        type: "fiat",
        amount: balance?.balance?.amount ?? 0,
        euroAmount: undefined, // no euro conversion for fiat
        code: currency.code ?? "",
      }
    );
  } else {
    const exchange = getExchangeRate(currency.code ?? "", fiatCurrencyCode, currencyDefinitions);
    const exchangeRate = exchange.rate ?? 0;
    const amount = balance.balance?.amount ?? 0;
    const exchangedAmount = new Big(amount).times(new Big(exchangeRate));

    return (
      {
        type: "crypto",
        amount: amount,
        euroAmount: exchangedAmount,
        code: currency.code ?? "", //BTC
      }
    );
  }
};

